import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import type { QuoteStatus, QuoteView } from "@contracts/index";
import { ErrorBox } from "../../components/AdminLayout";
import { api, errorMessage } from "../../lib/api";
import { formatDate, formatMoney, STATUS_LABEL, statusLabel } from "../../lib/format";

const FILTERS: Array<QuoteStatus | ""> = ["", "draft", "sent", "viewed", "accepted", "cancelled"];

export function QuoteList() {
  const [status, setStatus] = useState<QuoteStatus | "">("");
  const [quotes, setQuotes] = useState<QuoteView[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setQuotes(null);
    api.admin
      .listQuotes(status || undefined)
      .then(setQuotes)
      .catch((e: unknown) => setError(errorMessage(e)));
  }, [status]);

  return (
    <section className="card">
      <div className="row">
        <h1 className="grow">Cotizaciones</h1>
        <select value={status} onChange={(e) => setStatus(e.target.value as QuoteStatus | "")}>
          {FILTERS.map((f) => (
            <option key={f} value={f}>
              {f ? STATUS_LABEL[f] : "Todas"}
            </option>
          ))}
        </select>
        <Link className="button primary" to="/admin/quotes/new">
          Nueva cotización
        </Link>
      </div>
      <ErrorBox message={error} />
      {quotes === null && !error && <p className="muted">Cargando…</p>}
      {quotes?.length === 0 && <p className="muted">No hay cotizaciones.</p>}
      {quotes && quotes.length > 0 && (
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Folio</th>
                <th>Cliente</th>
                <th>Título</th>
                <th>Estado</th>
                <th className="num">Total</th>
                <th>Vigencia</th>
              </tr>
            </thead>
            <tbody>
              {quotes.map((q) => (
                <tr key={q.id}>
                  <td>
                    <Link to={`/admin/quotes/${q.id}`}>{q.folio}</Link>
                  </td>
                  <td>{q.client.name}</td>
                  <td>{q.title}</td>
                  <td>
                    <span className={`badge ${q.expired ? "expired" : q.status}`}>{statusLabel(q.status, q.expired)}</span>
                  </td>
                  <td className="num">{formatMoney(q.totals.totalCents, q.currency, q.language)}</td>
                  <td>{formatDate(q.validUntil)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
